/**
 * Default visual constants for the ForceDirectedGraph component.
 */
export const DEFAULT_NODE_COLOR = '#64748b';
export const DEFAULT_NODE_SIZE = 10;
export const DEFAULT_LINK_COLOR = '#94a3b8';
export const DEFAULT_LINK_WIDTH = 1;

/**
 * Layout and interaction thresholds.
 */
export const CIRCULAR_LAYOUT_RADIUS_RATIO = 0.35;
export const FIT_VIEW_PADDING = 40;
export const ZOOM_MIN_SCALE = 0.1;
export const ZOOM_MAX_SCALE = 10;

/**
 * Transition and animation durations.
 */
export const TRANSITION_DURATION_MS = 300;

/**
 * Package boundary styling.
 */
export const PACKAGE_BOUNDARY_FILL = 'rgba(148,163,184,0.06)';
export const PACKAGE_BOUNDARY_STROKE = '#475569';
export const PACKAGE_BOUNDARY_STROKE_WIDTH = 2;
export const PACKAGE_BOUNDARY_DASH = '6 6';
export const PACKAGE_LABEL_FONT_SIZE = 11;
export const PACKAGE_LABEL_COLOR = '#475569';
